/**
 * Frontend view of the backend feature-flag registry (GET /config).
 * Keep these keys in sync with `FEATURE_FLAG_REGISTRY` on optima-backend.
 */
export interface FeatureFlags {
    /** Show the EasyFlex worker page/tab + reg-number column. */
    easyflexPage: boolean;
    /** Expose the "Show archived" view on the worker table (dev only). */
    showArchivedWorkers: boolean;
    /** Expose the /admin/debug testing page (WhatsApp injection tools). */
    debugTools: boolean;
    /** Admit the complete deterministic-first conversation V2 release. */
    conversationRoutingV2: boolean;
}

/**
 * Fail-closed defaults, used before /config resolves and if the fetch fails.
 * Everything defaults OFF so a network blip hides an unreleased feature rather
 * than exposing it. The backend is the source of truth in the normal case.
 */
export const DEFAULT_FEATURE_FLAGS: FeatureFlags = {
    easyflexPage: false,
    showArchivedWorkers: false,
    debugTools: false,
    conversationRoutingV2: false,
};
